import { useColorMode } from "@chakra-ui/react";

const LitecoinSvg = () => {
  const theme = useColorMode().colorMode;

  const fill = theme === "dark" ? "#fff" : "#345D9D";

  const svgStyle = {
    enableBackground: "new 0 0 2500 704",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 2500 704"
      style={svgStyle as React.CSSProperties}
    >
      <g id="Layer_x0020_1">
        <g id="_1929822230160">
          <g>
            <path
              fill={fill}
              d="M352.8,0C158.4,0,0.8,157.6,0.8,352s157.6,352,352,352s352-157.6,352-352C704.4,157.6,547.1,0,352.8,0     L352.8,0z M358,363.3L321.6,487h195.6c6.9,0,11.3,6.5,9.7,12.9l-17,58.6c-1.6,5.7-6.9,9.7-12.9,9.7H198l50.5-170.9l-55.8,17.4     l12.1-40.4l56.2-17.4l71.1-240c1.6-5.7,6.9-9.7,12.9-9.7h75.6c6.9,0,11.3,6.5,9.7,12.9l-60.2,202.9l55.8-17.4l-12.1,40.8     L358,363.3z"
            ></path>
          </g>
          <path
            fill={fill}
            d="M908,106.7h-21.8c-4,0-6.9,2.4-7.7,6.5L822,561.3c-0.4,4.4,0.8,6.5,5.3,6.5l21.8,0c4.4,0,6.9-2,7.7-6.5    l57-448.2C914.9,108.7,912.5,106.7,908,106.7L908,106.7z"
          ></path>
          <path
            fill={fill}
            d="M1022.4,236h-21.8c-4,0-6.9,2-7.7,6.5l-40.4,319.3c-0.4,4.4,2,6.5,6.1,6.5h21.8c4,0,6.9-2,7.7-6.5l40-318.9    C1028.5,238.4,1026.8,236,1022.4,236z"
          ></path>
          <g>
            <path
              fill={fill}
              d="M1978.6,230.8c-30.3,0-56.6,8.5-78.8,25.9c-22.2,17.4-36.8,40-44,68.3c-6.1,23-11.3,55.4-13.7,77.2     c-3.2,29.5-6.1,53.7-6.1,77.2c0.4,28.7,9.7,51.3,27.1,68.7c17.8,17,42,25.9,72.7,25.9c29.9,0,56.2-8.5,78.4-25.9     c22.2-17,36.8-40,44.1-68.7c4.8-19,9.7-44.5,13.7-77.2c4-34,6.1-59.8,6.1-77.6c0-28.3-8.9-50.9-26.7-67.9     C2033.2,239.3,2008.9,230.8,1978.6,230.8L1978.6,230.8L1978.6,230.8z M2040,371c-2,16.2-3.2,26.7-3.6,31.1     c-4,33.1-7.7,56.6-10.9,70.7c-4.8,21-15.4,38-31.1,50.9c-15.8,12.9-34.4,19-55,19c-21,0-37.6-6.5-50.1-19     c-12.5-12.5-18.6-29.1-18.6-49.7c0-10.9,1.2-24.7,3.2-40.8c2-16.2,3.2-26.7,3.6-31.1c4-31.5,7.7-55,10.9-70.7     c4.9-21,15.4-38,31.1-50.9c15.8-12.9,34.4-19,55-19c21,0,37.6,6.5,50.1,18.6c12.5,12.5,18.6,29.1,18.6,49.7     C2043.3,341.5,2042,354.8,2040,371L2040,371z"
            ></path>
          </g>
          <path
            fill={fill}
            d="M2202.5,236h-21.4c-4,0-6.9,2.4-7.7,6.5l-40.8,319.3c-0.4,4.4,2,6.5,6.1,6.5h21.8c4,0,6.9-2,7.7-6.5l40-318.9    C2208.5,238.4,2206.9,236,2202.5,236L2202.5,236z"
          ></path>
          <path
            fill={fill}
            d="M2478.1,255c-15-15.8-36-23.4-63.5-23.4c-17.8,0-33.9,3.2-48.9,10.1c-15,6.9-27.5,17-38,30.7    c-2,1.6-2.8,1.2-2.8-1.2l3.2-28.3c0.4-4-1.2-6.5-5.3-6.5h-21.8c-4,0-6.9,2.4-7.7,6.5l-40,318.9c-0.4,4.1,0.8,6.5,5.3,6.5h21.8    c4,0,6.9-2.4,7.3-6.5l29.1-228.7c4.8-21.4,15-38.8,29.9-51.3c15-12.5,32.7-19,53.8-19c19.4,0,34.8,6.1,46.1,18.2    c11.3,12.1,17,28.3,17,48.9c0,6.1-0.4,10.9-0.8,14.5l-27.9,217.4c0,2,0,3.2,0.8,4.4c1.2,1.2,2.8,2,5.3,2h21.8c4,0,6.9-2,7.3-6.5    l27.9-222.7c0.8-8.9,1.2-15.4,1.2-19.8C2500.3,291.8,2493.1,270.4,2478.1,255L2478.1,255z"
          ></path>
          <path
            fill={fill}
            d="M1036.6,107.1c-12.9-6.9-29.5-2-36,11.3c-6.9,12.9-1.6,29.5,11.3,36.4c12.9,6.9,29.1,1.6,36-11.3    C1054.7,130.1,1049.9,114,1036.6,107.1z"
          ></path>
          <path
            fill={fill}
            d="M2218.2,107.1c-12.9-6.9-29.5-2-36,11.3c-6.9,12.9-1.6,29.5,11.3,36.4c12.9,6.9,29.5,1.6,36.4-11.3    C2236.4,130.1,2231.2,114,2218.2,107.1z"
          ></path>
          <path
            fill={fill}
            d="M1694.1,230.8c-30.3,0-56.6,8.9-78.8,25.9c-22.2,17.4-36.8,40-44,68.3c-6.1,23-11.7,59.4-13.7,77.2    c-2.8,25.9-6.1,53.7-6.1,77.2c0.4,28.7,9.7,51.3,27.1,68.7c17.8,17,42,25.9,72.8,25.9c29.9,0,56.2-8.5,78.4-25.9    c22.2-17,36.8-40,44-68.7c0.4-2.4,1.2-4.9,1.6-7.3c0.4-2-1.2-3.6-2.8-3.6h-27.1c-1.6,0-3.6,0.8-4,3.2c0,0.4-0.4,1.2-0.4,1.2    c-4.9,21-15.4,38-31.1,50.9c-15.8,12.9-34.4,19-55,19c-21,0-37.6-6.5-50.1-19c-12.5-12.5-18.6-29.1-18.6-49.7    c0-10.9,1.2-24.7,3.2-40.8c1.6-13.7,3.2-26.7,3.6-31.1c4-31.5,7.7-55,10.9-70.7c4.8-21,15.4-38,31.1-50.9c15.8-12.9,34.4-19,55-19    c20.6,0,37.6,6.1,50.1,18.6c12.5,12.5,18.6,29.1,18.6,49.7v0.4c0,2.8,2.4,5.3,5.3,5.3h25.5c2,0,4-1.6,4-4c0-2.8,0-5.3,0-7.7    c0-28.3-8.9-50.9-26.7-67.9C1748.6,239.3,1724.8,230.8,1694.1,230.8L1694.1,230.8z"
          ></path>
          <g>
            <path
              fill={fill}
              d="M1474.6,256.6c-17.8-17-42-25.9-72.3-25.9c-30.3,0-56.6,8.5-78.8,25.9c-22.2,17.4-36.8,40-44,68.3     c-6.1,23-8.9,43.7-13.7,77.2c-4.4,33.1-6.1,53.7-6.1,77.2c0.4,28.7,9.7,51.3,27.1,68.7c17.8,17,42,25.9,72.7,25.9     c29.9,0,56.2-8.5,78.4-25.9c22.2-17,36.8-40,44-68.7c0.4-2.4,1.2-4.9,1.6-7.3c0.4-2-0.8-3.6-2.8-3.6h-27.1c-1.6,0-3.6,0.8-4,3.2     c0,0.4-0.4,1.2-0.4,1.2c-4.8,21-15.4,38-31.1,50.9c-15.8,12.9-34.3,19-55,19c-21,0-37.6-6.5-50.1-19     c-12.5-12.5-18.6-29.1-18.6-49.7c0-9.7,0.8-21.8,2.4-35.6l196.4-61c4-1.2,5.7-3.2,6.5-8.1c1.2-10.1,2-27.5,2-45.3     C1501.3,298.7,1492.4,273.6,1474.6,256.6L1474.6,256.6L1474.6,256.6z M1467,348.4c0,2-1.2,3.6-3.2,4l-162.9,50.5     c0-0.4,0-0.4,0-0.8c4-31.5,7.7-55,10.9-70.7c4.8-21,15.4-38,31.1-50.9c15.8-12.9,34.4-19,55-19c21,0,37.6,6.5,50.1,18.6     C1467.8,300.7,1468.2,321.7,1467,348.4L1467,348.4z"
            ></path>
          </g>
          <path
            fill={fill}
            d="M1184.9,533.1c4-2,8.5,0.8,7.7,5.3l-2.8,21.8c-0.4,2.8-2.4,5.3-4.8,6.5c-19.4,7.3-46.5,10.5-68.3,0.8    c-25.1-11.3-31.5-36-27.9-66.7l28.7-234l4-33.5l9.7-74.4c0.4-4.4,3.2-6.5,7.7-6.5h21c4.8,0,6.1,2.8,5.3,6.5l-12.5,105.9h68.3    c4,0,5.7,2.4,5.7,6.5l-2,15.4c-0.4,2.4-0.8,3.6-2,5.3c-1.2,1.2-3.6,1.6-5.3,1.6h-67.9l-23.8,192c-2.4,20.6-5.2,39.2,5.3,49.3    C1144.5,546,1171.1,539.5,1184.9,533.1L1184.9,533.1z"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default LitecoinSvg;
